import {
  DOC_FLOW_RESULT_EMAIL_STATUS_FILTER_NAME,
  DOC_FLOW_RESULT_EPOST_STATUS_FILTER_NAME,
  DOC_FLOW_RESULT_SAVED_TO_PROFILE_STATUS_FILTER_NAME,
} from './docFlow'
import {
  DOC_FLOW_COMBINING_ENTITY,
  DOC_FLOW_SENDING_ENTITY,
  INHABITANT_ENTITY,
} from './entity'

export const TOGGLE_FILTER_TYPE = 'toggle'

export const DATE_FILTER_TYPE = 'date'

export const DATE_HIDDEN_TIME_FILTER_TYPE = 'date_with_hidden_time'

export const MULTISELECT_FILTER_TYPE = 'multiselect'

export const NUMBER_RANGE_FILTER_TYPE = 'number_range'

export const SELECT_FILTER_TYPE = 'select'

export const CUSTOM_FILTER_TYPE = 'custom'

export const HIDDEN_FILTER_TYPE = 'hidden'

// FILTER NAMES

export const ACTIVE_FILTER_NAME = 'active'

export const ARCHIVED_FILTER_NAME = 'archived'

export const UNREAD_FILTER_NAME = 'unread'

export const AREA_FILTER_NAME = 'area'

export const ASSIGNEE_FILTER_NAME = 'assignee'

export const AUTOMATIONS_FILTER_NAME = 'automations'

export const BUILDING_FILTER_NAME = 'building'

export const FLAT_FILTER_NAME = 'flat'

export const CHATS_FILTER_NAME = 'chats'

export const CREATED_FILTER_NAME = 'created'

export const DUE_DATE_FILTER_NAME = 'due_date'

export const DOCUMENTS_FILTER_NAME = 'files'

export const EMAILS_FILTER_NAME = 'emails'

export const HAS_CONTRACTORS_FILTER_NAME = 'has_contractors'

export const LIVE_AREA_FILTER_NAME = 'live_area'

export const MANAGER_FILTER_NAME = 'manager'

export const PRIVATE_UPDATED_FILTER_NAME = 'private_updated'

export const RATING_FILTER_NAME = 'rating'

export const ROLE_FILTER_NAME = 'role'

export const STAFF_MEMBER_FILTER_NAME = 'staff_member'

export const STATUS_FILTER_NAME = 'status'

export const TASK_STATUS_FILTER_NAME = 'activity_status'

export const VISIBLE_TO_TENANT_FILTER_NAME = 'visible_to_tenant'
// END FILTER NAMES

// FILTER VALUES (idwell-api enums)

export const DATE_RANGE_FILTER_TODAY = 'today'

export const DATE_RANGE_FILTER_WITH_OVERDUE_DATE = 'with_overdue_date'

export const TASK_STATUS_FILTER_OPEN = 'open'
// END FILTER VALUES

export const USER_FILTER_LIST = [
  'assignee',
  'dwellers',
  'flat_dwellers',
  'flat_landlords',
  'landlords',
  'closed_by',
  'completed_by',
  'contractor',
  'created_by',
  'inhabitant',
  'inhabitants',
  'manager',
  'owner',
  'participant',
  'property_owner',
  'recipient',
  'request_owner',
  'responsible_manager',
  'responsible_user',
  'updated_by',
  'worker',
  'staff_members',
  'contractors',
  'external_contacts',
]

export const USER_LIST_TYPE = 'user'

export const RATING_LIST_TYPE = 'rating'

export const LABEL_LIST_TYPE = 'label'

export const FILE_LIST_TYPE = 'file'

export const FLOAT_LIST_TYPE = 'float'

export const STATUS_LIST_TYPE = 'status'

export const DATE_LIST_TYPE = 'date'

export const DATE_FILTER_TYPES = [
  DATE_FILTER_TYPE,
  DATE_HIDDEN_TIME_FILTER_TYPE,
]

export const RAW_DATE_KEY = 'rawDateValue'

export const ATTACH_FIELD_NAME = 'attachment'

export const FILE_FIELD_NAME = 'file'

export const UPLOADING_FIELD_NAME = 'uploading'

export const FILE_FILTER_LIST = [
  ATTACH_FIELD_NAME,
  FILE_FIELD_NAME,
  UPLOADING_FIELD_NAME,
]

export const DOC_FLOW_RESULT_STATUS_FILTER_LIST = [
  DOC_FLOW_RESULT_EMAIL_STATUS_FILTER_NAME,
  DOC_FLOW_RESULT_EPOST_STATUS_FILTER_NAME,
  DOC_FLOW_RESULT_SAVED_TO_PROFILE_STATUS_FILTER_NAME,
]

export const INHABITANT_STATUS_LIST = [
  INHABITANT_ENTITY,
  DOC_FLOW_SENDING_ENTITY,
  DOC_FLOW_COMBINING_ENTITY,
]

export const FILTER_NAME_SUB_MENU = 'sub_menu'
